/* eslint-disable no-console */
import * as swatches from './modules/swatchbook/swatchbook-swatches';
import * as photos from './modules/swatchbook/swatchbook-photos';
import * as products from './modules/swatchbook/swatchbook-products';
import * as dealer from './modules/swatchbook/swatchbook-dealer';
import * as visualizations from './modules/swatchbook/swatchbook-visualizations';

// console.log('\n\n\n*************************\n\nswatchbook.js ver: 2.0.5 \n\n*************************\n\n\n');

const { isVisualizerActive } = window;

const updateSwatchbook = () => {
  // Show print/download/order buttons only if there's content
  let noContentCheck = !swatches.hasItems() && !photos.hasItems() && !products.hasItems() && !dealer.hasItems();
  if (isVisualizerActive) {
    noContentCheck = !swatches.hasItems() && !photos.hasItems() && !products.hasItems() && !dealer.hasItems() && !visualizations.hasItems();
  }
  if (noContentCheck) {
    document.querySelector('#download-swatchbook-pdf').classList.add('hidden');
    document.querySelector('#print-swatchbook').classList.add('hidden');
  } else {
    document.querySelector('#download-swatchbook-pdf').classList.remove('hidden');
    document.querySelector('#print-swatchbook').classList.remove('hidden');
  }
  if (!swatches.hasItems()) {
    document.querySelector('#place-order').classList.add('hidden');
  } else {
    document.querySelector('#place-order').classList.remove('hidden');
  }
};

const enqueuePdfUtilsData = (data) => {
  const { pdfUtils } = window;
  // console.log(data);
  pdfUtils.data.items.push.apply(pdfUtils.data.items, data); /* eslint-disable-line prefer-spread */
};

const removePageItemById = (data, id) => {
  const index = data.findIndex(item => id.toString() === item.assetId.toString());
  data.splice(index, 1);
};

const getItemById = (data, id) => (
  data.find(item => id.toString() === item.assetId.toString())
);

const init = () => {
  const { pdfUtils } = window;
  pdfUtils.data = { items: [], cart: [] };
  swatches.init({
    enqueuePdfUtilsData,
    removePageItemById,
    updateSwatchbook,
  });
  photos.init({
    enqueuePdfUtilsData,
    getItemById,
    removePageItemById,
    updateSwatchbook,
  });
  products.init({
    enqueuePdfUtilsData,
    getItemById,
    removePageItemById,
    updateSwatchbook,
  });
  dealer.init({
    enqueuePdfUtilsData,
    getItemById,
    removePageItemById,
    updateSwatchbook,
  });
  if (isVisualizerActive) {
    visualizations.init({
      enqueuePdfUtilsData,
      getItemById,
      removePageItemById,
      updateSwatchbook,
    });
  }
  // Add print/download pdf handlers
  const downloadBtn = document.querySelector('#download-swatchbook-pdf');
  downloadBtn.addEventListener('click', () => {
    pdfUtils.printAndDownload(downloadBtn, 'download');
  });
  const printBtn = document.querySelector('#print-swatchbook');
  printBtn.addEventListener('click', () => {
    pdfUtils.printAndDownload(printBtn, 'print');
  });
};

export default {
  init,
};

if (document.querySelector('.swatchbook-app')) {
  init();
}
/* eslint-enable no-console */
